import { createBrowserRouter } from "react-router-dom";
import ProtectedRoute from "../auth/protected-route";
import LoginForm from "../components/PreviewWindow/Samples/Login";
import { enableMapSet } from "immer";
import Publisher from "../page/publisher";
import Editor from "../page/editor";
import User from "../page/user";
import ThemeGallery from "../page/themeGallery";
import LoginUser from "../components/PreviewWindow/Samples/LoginUser";
import Error404 from "../page/error404";

enableMapSet();

export const router = createBrowserRouter([
  {
    path: "/",
    element: <LoginForm />,
  },
  {
    path: "/user-login",
    element: <LoginUser />,
  },
  {
    path: "/publisher-dashboard",
    element: (
      <ProtectedRoute allowedRole="publisher">
        <Publisher />
      </ProtectedRoute>
    ),
  },
  {
    path: "/editor-dashboard",
    element: (
      <ProtectedRoute allowedRole="editor">
        <Editor />
      </ProtectedRoute>
    ),
  },
  {
    path: "/user-dashboard",
    element: (
      <ProtectedRoute allowedRole="user">
        <User />
      </ProtectedRoute>
    ),
  },
  {
    path: "/theme-gallery",
    element: <ThemeGallery />,
  },
  {
    path: "*",
    element: <Error404 />,
  },
]);
